import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import 'react-datepicker/dist/react-datepicker.css';
import ModalAddSerialNumberOverlayDialog from '../../../dialogs/modalAddSerialNumberOverlayDialog';
import AccountNumberAutoSuggests from '../../common/accountNumberAutoSuggests';

import _ from 'lodash';
import moment from 'moment';

/* Actions */
import {
	setRequestCreditDetails,
	getAccountList,
} from '../../../../redux/actions';

import {
	sendRequest
} from '../../../../redux/api/sendRequest';

import { routes } from '../../../../redux/api/routes';
const {
	bootAPIUrl,
	users,
} = routes;

class RequestCreditStep2 extends Component {

	constructor(props) {
		super(props);
		this.state = {
			batchSizeForAddressList: 30,
			accountNumberDetails: [],
			requestCreditStep2Form: {
				params: {
					orderDate: moment().format('MM/DD/YYYY'),
					orderType: 'Return Order',
					poNumber: '',
					deliveryPhone: '',
					creditInvoiceNotes: '',

					accountNumber: '',
					agreementNumber: '',
					createdById: '',
					createdBy: '',
					email: '',
				},
				errors: {
					poNumberError: '',
					deliveryPhoneError: '',
				},
			},
			// date: null,
			showModalAddSerialNumberOverlayDialog: false,
			selectedSerialNumber: [],
			selectedIndex: null,
			originalSerialNumbers: [],
		};
		// this.handleChange = this.handleChange.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.fetchAllDetailsForCreditAsISPriceAdjustmentPage = this.fetchAllDetailsForCreditAsISPriceAdjustmentPage.bind(this);
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		// Redirect to request return page if there is no data in store, it means page is refreshed
		if(!this.props.order.requestCreditDetails) {
			browserHistory.push("/requestcredit");
		} else {
			const self = this;
			const { userDetails,selectedAccount } = self.props.user;
			const orderDetails = self.props.order.requestCreditDetails && self.props.order.requestCreditDetails.responseObject;
			let customerClassCodeValue = _.lowerCase(selectedAccount.CUSTOMERCLASSCODE) || "";
			self.setState({
				requestCreditStep2Form: {
					...self.state.requestCreditStep2Form,
					params: {
						...self.state.requestCreditStep2Form.params,
						billingAddress: orderDetails.billingAddress,
						accountNumber: self.props.getSelectedAccountNumber(),
						agreementNumber: orderDetails.agreementNumber,
						createdById: userDetails.sso,
						createdBy: userDetails.firstName + " " + userDetails.lastName,
						emailId: userDetails.email,
						userType: userDetails.typeOfUser,
					}
				},
				 customerClassCode : customerClassCodeValue,
			});
		}
	}

	onChangeUpdateParam(event) {
        var self = this;
		const value = event.target.name === 'poNumber' ? event.target.value.toUpperCase() : event.target.value,
			name = event.target.name;
		// event.target.value = value;
		let errors = self.state.requestCreditStep2Form.errors;
		self.setState({
			requestCreditStep2Form: {
				...self.state.requestCreditStep2Form,
				params: {
					...self.state.requestCreditStep2Form.params,
					[name]: value,
				},
				errors
			}
        }, () => {
			if(self.state.requestCreditStep2Form.errors[name + 'Error']) {
				self.setState({
					requestCreditStep2Form: {
						...self.state.requestCreditStep2Form,
						errors: {
							...self.state.requestCreditStep2Form.errors,
							[name+"Error"]: ""
						}
					}
		        });
			}
		});
    }

	componentWillMount() {
		const self = this;
		const orderDetails = self.props.order.requestCreditDetails && self.props.order.requestCreditDetails.responseObject;
		if(orderDetails) {
			// Add 2 business days for requested delivery date
			const creditType = self.props.order.requestCreditFilterListOfOrders && self.props.order.requestCreditFilterListOfOrders.param ? self.props.order.requestCreditFilterListOfOrders.param.creditType: '';
			const items = orderDetails.items;
			if (creditType === 'As-is Credit/Rebill') {
				items.forEach(item => {
					if(item.selected) {
						item.reasonCategory = 'CR_RB_ASIS_ACCT';
						item.reasonCategoryLabel = 'Credit Rebill AsIs Change Account';
						item.reasonCategoryError = '';
						item.reasonCategoryValue = JSON.stringify({
							label: 'Credit Rebill AsIs Change Account',
							value: 'CR_RB_ASIS_ACCT'
						});
					}
				})
			}
			let poNumber = orderDetails.poNumber.indexOf('CR-') !== 0 ? `CR-${orderDetails.poNumber}` : orderDetails.poNumber;
			poNumber = poNumber.substring(0, 50);
			self.setState({
				creditType,
				requestCreditStep2Form: {
					...self.state.requestCreditStep2Form,
					params: {
						...this.state.requestCreditStep2Form.params,
						items,
						creditInvoiceNotes: orderDetails.creditInvoiceNotes || '',
						poNumber,
						deliveryPhone: this.props.normalizePhoneNumber(orderDetails.deliveryPhone),

						accountNumber: orderDetails.accountNumber,
						agreementNumber: orderDetails.agreementNumber,
						createdById: orderDetails.createdById,
						createdBy: orderDetails.createdBy,
						email: orderDetails.email,
					}
				}
			});
		}
	}

	onDeleteItem(index, event) {
		event.preventDefault();
		const orderDetails = this.props.order.requestCreditDetails;
		orderDetails.responseObject.items.forEach((item, indx) => {
			if(index === indx) {
				delete item.selected; // updatedItems.push(item);
			}
		});
		if(orderDetails.responseObject.items.filter(item => item.selected).length === 0) {
			browserHistory.push('/requestcredit');
			this.props.setRequestCreditDetails(null);
		} else {
			// orderDetails.responseObject.items = updatedItems;
			this.props.setRequestCreditDetails(orderDetails);
		}
	}

	onBlurValidatePhoneNumber(event) {
		var self = this,
			requestCreditStep2Form = this.state.requestCreditStep2Form;

        //Reset Error flag first
    	requestCreditStep2Form.errors.deliveryPhoneError = "";

        //Update current value
		requestCreditStep2Form.params.deliveryPhone = event.target.value;

		if(requestCreditStep2Form.params.deliveryPhone !== "" && self.props.isValidPhoneNumber(requestCreditStep2Form.params.deliveryPhone)) {
			requestCreditStep2Form.errors.deliveryPhoneError = "";
			var formattedNum = self.props.normalizePhoneNumber(event.target.value);
			requestCreditStep2Form.params.deliveryPhone = formattedNum;
			event.target.value = formattedNum;
		}

        self.setState({
            requestCreditStep2Form
        });
	}

	onChangeUpdateItems(indx, event) {
		let orderDetails = this.props.order.requestCreditDetails;
		orderDetails.responseObject.items.forEach((item, index) => {
			if(indx === index) {
				item[event.target.name] = event.target.type === 'checkbox'?event.target.checked:event.target.value;
				if(event.target.name === 'reasonCategory') {
					const value = event.target.value ? JSON.parse(event.target.value) : null;
					item.reasonCategory = value ? value.value : '';
					item.reasonCategoryLabel = value ? value.label : '';
					item.reasonCategoryError = '';
					item.reasonCategoryValue = event.target.value;
					item.subbedModel = '';
					item.subbedModelError = '';
				}
				if(event.target.name === 'serialNumber') {
					item.serialNumberError = "";
				}
			} else if(event.target.name === 'reasonCategory' && !item.reasonCategoryValue) {
				const value = event.target.value ? JSON.parse(event.target.value) : null;
				item.reasonCategory = value ? value.value : '';
				item.reasonCategoryLabel = value ? value.label : '';
				item.reasonCategoryError = '';
				item.reasonCategoryValue = event.target.value;
			}
		});
		this.props.setRequestCreditDetails(orderDetails);
	}

	handleSubmitStep2(event) {
		event.preventDefault();
		var self = this,
            requestCreditStep2Form = self.state.requestCreditStep2Form,
            formError = false;
		const { CUSTOMERCLASSCODE} = self.props.user.accountDetail.responseObject !== null && self.props.user.accountDetail.responseObject !== 'undefined' ? self.props.user.accountDetail.responseObject[0]: '';
		
        for(var key in requestCreditStep2Form.errors) {
            if(!requestCreditStep2Form.params[key.replace("Error","")]) {
                requestCreditStep2Form.errors[key] = 'error';
                formError = true;
            }
        }

		// Check for phone number validity
		if(requestCreditStep2Form.params.deliveryPhone !== "" && !self.props.isValidPhoneNumber(requestCreditStep2Form.params.deliveryPhone)) {
			formError = true;
			requestCreditStep2Form.errors.deliveryPhoneError = "error";
		}
		const { selectedAccount } = self.props.user;
		// Check for notes, reason type or reason for return request in items
		const orderDetails = self.props.order.requestCreditDetails;
		orderDetails.responseObject = {
			...orderDetails.responseObject,
			accountDescription: selectedAccount.ACCOUNTDESCRIPTION
		};
		orderDetails.responseObject.items.forEach((item, index) => {
			if(item.selected) {
				item.accountNumber = selectedAccount.ACCOUNTNUMBER;
				item.accountDescription = selectedAccount.ACCOUNTDESCRIPTION;
				item.originalAccountNumber = selectedAccount.ACCOUNTNUMBER;
				item.originalAccountDescription = selectedAccount.ACCOUNTDESCRIPTION;
				item.originalAgreementNumber = item.agreementNumber;
				item.originalAgreementName = item.agreementName;
				/*if(!item.notes) {
					item.notesError = "error";
					formError = true;
				} else {
					item.notesError = ""
				}*/
				if(self.state.creditType !== 'Delivery/Services/Fees' && item.itemType !== 'A' && !item.serialNumber) {
					item.serialNumberError = "error";
					formError = true;
				} else if(self.state.creditType !== 'Delivery/Services/Fees' && item.itemType !== 'A' && item.originalSerialNumbers && item.serialNumber.split(" ").length !== parseInt(item.returnQuantity, 10)) {
					formError = true;
					item.serialNumberError = "error";
				} else if(self.state.creditType !== 'Delivery/Services/Fees' && item.itemType !== 'A' && !item.originalSerialNumbers) {
					const inpSerialNum = item.serialNumber.length>0 ? item.serialNumber : item.userItemDescription;
					const splitItem = inpSerialNum.split(",");
					const enteredSerialNumbers = splitItem.map(itm=>itm + ' ').join('').trim().split(",");
					const actualCorrectSerialNumbers = [];
					enteredSerialNumbers.forEach(itm => {
						if(itm.trim()) {
								if(splitItem.length == 1 )  {
									actualCorrectSerialNumbers.push(itm.trim());
							}
							else {if(splitItem.length > 1 && itm.trim().indexOf(" ") == -1){
								formError = true;
								item.serialNumberError = "error";
							}
							actualCorrectSerialNumbers.push(itm.trim());
						}
						}
					});
					if(actualCorrectSerialNumbers.length !== parseInt(item.returnQuantity, 10) && (item.serialNumber && item.serialNumber.trim()[item.serialNumber.trim().length - 1] === ',')) {
						formError = true;
						item.serialNumberError = "error";
					}
				} else {
					item.serialNumberError = "";
				}
				if ((item.reasonCategoryLabel === 'Credit Pricing Contract Substitution' || item.reasonCategoryLabel === 'Credit Pricing Retail ABD Substitution') && !item.subbedModel) {
					formError = true;
					item.subbedModelError = "error";
				}
				if(!item.reasonCategory) {
					item.reasonCategoryError = "error";
					formError = true;
				} else {
					item.reasonCategoryError = ""
				}
			}
		});
		self.props.setRequestCreditDetails(orderDetails);

		self.setState({
			requestCreditStep2Form
		}, () => {
			if(!formError) {
				orderDetails.responseObject = {
					...orderDetails.responseObject,
					...self.state.requestCreditStep2Form.params,
				}
				// check if existing address id is valid or note
				// if not valid then pick the default selected address for header selected account number
				const addressDetails = self.props.getCombinedAddresses().find(item => item.PURPOSE === 'SHIP_TO' && item.SITE_USE_ID.toString() === orderDetails.responseObject.shippingAddress.addressId);
				if (!addressDetails) {
					orderDetails.responseObject = {
						...orderDetails.responseObject,
						shippingAddress: {
							...orderDetails.responseObject.shippingAddress,
							addressId: self.props.addressIdOfDefaultShippingAddress
						}
					};
				}
				if(self.state.creditType === 'Scrap') {
					orderDetails.responseObject.items.forEach((item, index) => {
						item.percentage = CUSTOMERCLASSCODE === "AS-IS" &&  moment(item.invoiceDate).isBefore(moment().subtract(180, 'days'), 'day') ? "50":"100";
						item.disabled = true;
					});
				} else if(self.state.creditType === 'Delivery/Services/Fees') {
					orderDetails.responseObject.items.forEach((item, index) => {
						item.percentage = "100";
					});
				}
				self.props.setRequestCreditDetails(orderDetails);
				const { creditType } = self.state;
				if(creditType === 'Scrap') {
					browserHistory.push("/requestCreditScrapPolicy");
				} else if(creditType === 'As-is Credit/Rebill' || creditType === 'Price Adjustment - Credit/Rebill') {
					// make call to fetch account details and all and then redirect to next page
					self.fetchAllDetailsForCreditAsISPriceAdjustmentPage(creditType, orderDetails);
				} else {
					browserHistory.push("/requestcreditstep3");
				}
			}
		});
	}

	pickTheDateFromString(dateStr, format = 'MM/DD/YYYY') {
		if(dateStr && dateStr.length >= 10) {
			return moment(dateStr.substring(0, 10)).format(format);
		} else {
			return '';
		}
	}

	fetchAllDetailsForCreditAsISPriceAdjustmentPage(creditType, requestCreditDetails) {
		const self = this;
		if(creditType === 'As-is Credit/Rebill') {
			requestCreditDetails.responseObject.items.forEach(item => {
				if(item.selected) {
					item.accountNumber = '';
					item.agreementName = '';
				}
			})
		}
		self.setState({
			requestCreditDetails,
		}, () => {
			self.fetchAccountList(() => {
				const orderDetails = self.state.requestCreditDetails.responseObject;
				const items = JSON.parse(JSON.stringify(orderDetails.items.filter(itm => itm.selected)));
				items.forEach(item => {
					item.item = item.subbedModel || item.item;
				});
				self.props.makePriceOrderServiceCall(orderDetails, items, orderDetails.accountNumber, self.state.accountNumberDetails, orderDetails.originalOrderDate, true, creditType, (response) => {
					const pricingData = response.responseObject;
					const requestCreditDetails = self.state.requestCreditDetails;
					// eslint-disable-next-line
					let indexCounter = 0;
					requestCreditDetails.responseObject.items.forEach((item, index) => {
						if(item.selected) {
							let salesPriceData = pricingData ? _.find(pricingData, itm => {
								// for now removed: itm.itemPrice.lineIndex === (indexCounter + 1).toString() && 
								return itm.itemPrice.item === (item.subbedModel || item.item) && item.returnQuantity.toString() === itm.itemPrice.qty.toString()
							}) : null;
							if (salesPriceData) {
								item.shouldBePrice = salesPriceData.itemPrice.salesPrice;
								item.originalShouldBePrice = salesPriceData.itemPrice.salesPrice;
								item.pricingDate =  self.pickTheDateFromString(item.pricingDate.split('T')[0])
								item.shouldBePriceError = "";
							} else {
								item.shouldBePrice = "";
								item.shouldBePriceError = "error";
							}
							indexCounter += 1;
						}
					});
					self.props.setRequestCreditDetails({
						...requestCreditDetails,
						accountNumberDetails: self.state.accountNumberDetails,
					});
					browserHistory.push("/requestCreditAsIsPriceAdjustment");
				});
			});

		});
	}

	fetchAccountList(callback) {
		const self = this;
		const { selectedAccount } = self.props.user;
		self.props.getAccountList("requestType=getAccountList&accountPartyId="+selectedAccount.PARTYID, response => {
			const accountNumberDetails = [];
			const { selectedAccount, selectedAccountsAllPriceSources } = self.props.user;
			if (self.state.creditType === 'Price Adjustment - Credit/Rebill') {
				accountNumberDetails.push({
					...selectedAccount,
					agreementNumberList: selectedAccountsAllPriceSources.responseObject,
				});
			}
			self.setState({
				accountNumberDetails
			}, () => {
				if(response && response.responseObject && response.responseObject.length) {
					response.responseObject = response.responseObject.filter(item => item.ACCOUNTNUMBER.toString() !== self.props.getSelectedAccountNumber() && item.STATUS !== 'I');
					if(self.state.creditType === 'As-is Credit/Rebill') {
						response.responseObject = response.responseObject.filter(item => item.CLASSIFICATION === 'AS-IS');
					} else {
						response.responseObject = response.responseObject.filter(item => item.CLASSIFICATION !== 'AS-IS');
					}
					let promises = [];
					response.responseObject.forEach(item => {
						// Get Order Details: getOrderDetails in parallel
						promises.push(
							sendRequest(
								bootAPIUrl,
								users.account.path,
								'',
								users.account.method,
								`accountNumber=${item.ACCOUNTNUMBER}&partyId=${item.PARTYID}&requestType=getAddressList`
							)
						);
					});
					promises = _.chunk(promises, self.state.batchSizeForAddressList);
					self.setState({
						noOfParallelCalls: promises.length,
						noOfCompletedCalls: 0,
						responses: [],
					}, () => {
						if (promises.length > 0) {
							promises.forEach(promise => {
								self.props.makeParallelCalls(promise, responses => {
									self.setState({
										noOfCompletedCalls: self.state.noOfCompletedCalls + 1,
										responses: self.state.responses.concat(responses)
									}, () => {
										if(self.state.noOfCompletedCalls === self.state.noOfParallelCalls) {
											let finalResponses = [];
											self.state.responses.forEach(itm => {
												if(itm.responseObject) {
													const responseObject = itm.responseObject.filter(it => it.STATUS === 'A' && (!it.PURPOSE_STATUS || it.PURPOSE_STATUS === 'A'));
													finalResponses = finalResponses.concat(responseObject);
												}
											});
											const accountList = self.state.accountNumberDetails;
											response.responseObject.forEach((item, i) => {
												const currentAccountAddresses = finalResponses.filter(it => it.ACCOUNT_NUMBER === item.ACCOUNTNUMBER);
												const billToAddresses = currentAccountAddresses && currentAccountAddresses.filter(it => it.PURPOSE === 'SOLD_TO');
												const defaultShipToAddress = currentAccountAddresses && currentAccountAddresses.find(it => it.PRIMARYINDICATOR === 'Y' && it.PURPOSE === 'SHIP_TO');
												if(billToAddresses && billToAddresses.length) {
													accountList.push({
														...item,
														agreementNumberList: [],
														defaultShipToAddress
													});
												}
											});
											self.setState({
												accountNumberDetails: accountList,
											}, () => {
												callback && callback();
											});
										}
									});
								});
							});
						} else {
							callback && callback();
						}
					});
				}
			});
		});
	}

	handleShowModalAddSerialNumber(selectedIndex, data, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			selectedSerialNumber: data.serialNumber,
			originalSerialNumbers: data.originalSerialNumbers !=""?data.originalSerialNumbers : data.userItemDescription,
			selectedIndex
		}, () => {
			self.handleDialog("ModalAddSerialNumberOverlayDialog", true);
		});
	}

	handleCallbackAfterSelect(selectedSerialNumber) {
		const self = this;
		const orderDetails = self.props.order.requestCreditDetails;
		orderDetails.responseObject.items[self.state.selectedIndex].serialNumber = selectedSerialNumber;
		orderDetails.responseObject.items[self.state.selectedIndex].serialNumberError = '';
		self.props.setRequestCreditDetails(orderDetails);
		self.handleDialog("ModalAddSerialNumberOverlayDialog", false);
	}

	handleGoToStep(step, event) {
		event.preventDefault();
		browserHistory.push(step);
	}

	checkTypeOfService(itemName) {
		const self = this;
		let itemType = '';
		itemName = itemName.toLowerCase();
		if(itemName === 'restocking fee') {
			itemType = 'restocking';
		} else if((itemName.length === 4 && itemName.indexOf("m") === 0) || self.props.getItemTypeByName(itemName) === 'S') {
			itemType = 'deliveryhandlingetc';
		} else if(itemName.indexOf('service contract') !== -1) {
			itemType = 'servicecontract';
		}
		return itemType;
	}

	fetchProperCreditReasonByItem(item) {
		const self = this;
		let creditTypeDropdownOptions = [];
		const serviceType = self.checkTypeOfService(item);
		if(serviceType) {
			creditTypeDropdownOptions = self.props.order.creditTypeDropdownValues[self.state.creditType];
			creditTypeDropdownOptions = creditTypeDropdownOptions.filter(item => item.serviceType === serviceType);
		}
		return creditTypeDropdownOptions;
	}

	handleChangeProductNumberTextBox(indx, productNumber, productListSuggestion, inValid) {
		const self = this;
		let orderDetails = self.props.order.requestCreditDetails;
		orderDetails.responseObject.items.forEach((item, index) => {
			if(indx === index) {
				item.subbedModel = productNumber;
				item.inValid = inValid;
			}
		});
		self.props.setRequestCreditDetails(orderDetails);
	}

	handleProductNumberChange(itemIndex, productDetails) {
		const self = this;
		if(productDetails && productDetails.status) {
			let orderDetails = self.props.order.requestCreditDetails;
			orderDetails.responseObject.items.forEach((item, index) => {
				if(itemIndex === index) {
					item.subbedModel = productDetails.sku;
					item.inValid = false;
				}
			});
			self.props.setRequestCreditDetails(orderDetails);
		}
	}

    render() {
		const self = this;
		const orderDetails = self.props.order.requestCreditDetails && self.props.order.requestCreditDetails.responseObject;
		const {
			requestCreditStep2Form: {
				params: {
					billingAddress
				}
			}
		} = self.state;
		let creditTypeDropdownOptions = self.props.order.creditTypeDropdownValues[self.state.creditType];
		const classCode = ['appliance builder distributor', 'apartment replacement distributor', 'aws pro distributors', 'commercial dist', 'hospitality distributor', 'oem dist'];
		const accessoryList = self.props.order && self.props.order.requestCreditPimdata && self.props.order.requestCreditPimdata.filter(item=>item.geego_accessory_indicator == "Y");
		return (
			<div>
				<div className="d-none d-sm-block">
					<div className="push">
						<h1 className="pageTitle">Request Credit</h1>
					</div>
					<form className="returnProductsForm" name="returnProductsForm" id="returnProductsForm">
						<div className="push">
							<table className="formTableTypeA">
								<tbody>
									<tr>
										<td>Credit Request Date</td>
										<td>{this.state.requestCreditStep2Form.params.orderDate}</td>
									</tr>
									<tr>
										<td>Order Type</td>
										<td>{this.state.requestCreditStep2Form.params.orderType}</td>
									</tr>
									<tr>
										<td>
											P.O.<br />
											<i className="unbold">(for your reference)</i>
										</td>
										<td>
											<input onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.onChangeUpdateParam, undefined, undefined)} className={'txt-uppercase ' + this.state.requestCreditStep2Form.errors.poNumberError} type="text" name="poNumber" onChange={this.onChangeUpdateParam.bind(this)} defaultValue={this.state.requestCreditStep2Form.params.poNumber} maxLength={50} />
										</td>
									</tr>
									<tr className="forPickupRequestsOnly">
										<td>
											Billing Address
										</td>
										<td>
											{billingAddress && <p className="billingAddress">
												{billingAddress.addressName && billingAddress.addressName.trim()}
												{billingAddress.addressName && billingAddress.addressName.trim() !== ""?<br/>:null}
												{billingAddress.address1 && billingAddress.address1.trim()}
												{billingAddress.address1 && billingAddress.address1.trim() !== ""?<br/>:null}
												{billingAddress.city && billingAddress.city.trim()}, {billingAddress.state && billingAddress.state.trim()} {billingAddress.zip && billingAddress.zip.trim()}<br />
												{billingAddress.phone}
											</p>}
										</td>
									</tr>
									<tr className="forPickupRequestsOnly">
										<td>
											Contact Phone
										</td>
										<td>
											<input onKeyPress={this.props.acceptNumbersOnly} onBlur={this.onBlurValidatePhoneNumber.bind(this)} className={"phoneNumberField "+this.state.requestCreditStep2Form.errors.deliveryPhoneError} type="text" onChange={this.onChangeUpdateParam.bind(this)} defaultValue={this.state.requestCreditStep2Form.params.deliveryPhone} name="deliveryPhone" size={17} maxLength={17} />
										</td>
									</tr>
									<tr className="forPickupRequestsOnly">
										<td>Credit Invoice Notes</td>
										<td className="containingTextArea">
											<textarea rows={6} cols={40} defaultValue={this.state.requestCreditStep2Form.params.creditInvoiceNotes} onChange={this.onChangeUpdateParam.bind(this)} name="creditInvoiceNotes" />
										</td>
									</tr>
								</tbody>
							</table>
						</div> {/* / .push */}
						<div className="push">
							<table className="dataTableType2 returnProductsTable">
								<thead>
									<tr>
										<th className="remove">Remove</th>
										<th className="product">Product</th>
										<th className="creditRequested">Quantity<br />To Credit</th>
										<th className="invoiceNumber">Invoice #</th>
										<th className="creditType">Credit Type</th>
										<th className="creditRequestReason">Reason For Credit Request</th>
									</tr>
								</thead>
								<tbody>
									{orderDetails && orderDetails.items.map((item, index) => {
										let accessoryListflag =false;
										if(item.item == accessoryList && accessoryList.product_attr_val_disp){
											accessoryListflag =true;
										}
										if (!item.selected) return null;
										let dropdownOptions = JSON.parse(JSON.stringify(creditTypeDropdownOptions));
										if (self.state.creditType === 'Delivery/Services/Fees') {
											dropdownOptions = JSON.parse(JSON.stringify(self.fetchProperCreditReasonByItem(item.item)));
										}
										// Substitution reason codes (“Credit Pricing Contract Substitution” or “Credit Pricing Retail ABD Substitution”)
										// should not be offered if original account is Retail and the SA is Quote Type N.
										if(self.state.creditType === 'Price Adjustment - Credit/Rebill' && self.state.customerClassCode !== "single family"){
											dropdownOptions = dropdownOptions.filter(itm => itm.label !== "Credit Display Model Home Allow Direct Contract Only")
										}
										if (self.state.creditType === 'Price Adjustment - Credit/Rebill' &&self.props.getAttributeBySalesAgreement(item.agreementNumber, 'Quote Type') === 'N' && self.props.getSelectedAccountType() === 'RETAIL' )
										{
											dropdownOptions = dropdownOptions.filter(itm => itm.label !== 'Credit Pricing Contract Substitution' && itm.label !== 'Credit Pricing Retail ABD Substitution');
										}
										if(self.state.creditType === 'Price Adjustment - Credit/Rebill' && (self.props.getSelectedAccountType() === 'RETAIL' || classCode.includes(self.state.customerClassCode))){
											dropdownOptions = dropdownOptions.filter(itm => 
												itm.label !== 'Credit Pricing Contract Exception Model Not On Quote'&&
												itm.label !== 'Credit Pricing Contract Late Addition Of Model To Quote'&&
												itm.label !== 'Credit Pricing Contract Price Change On Quote');
										}
										return [
											<tr key={100 + index} className={!(self.state.creditType !== 'Delivery/Services/Fees' && (item.originalSerialNumbers || item.userItemDescription)) ? 'borderBottom777' : ''}>
												<td className="remove" style={{borderBottom: '0 none'}} rowSpan={ self.state.creditType !== 'Delivery/Services/Fees' && accessoryListflag ? 2 : 1 }>
													<a className="deleteLink" href="" onClick={this.onDeleteItem.bind(this, index)} >✗</a>
												</td>
												<td className="product" style={{borderBottom: '0 none'}}>
													{item.item}
												</td>
												<td className="creditRequested" style={{borderBottom: '0 none'}}>{item.returnQuantity}</td>
												<td className="invoiceNumber" style={{borderBottom: '0 none'}}>{item.invoiceNumber}</td>
												<td className="creditType" style={{borderBottom: '0 none'}}>{this.state.creditType}</td>
												<td className="creditRequestReason" style={{borderBottom: '0 none', position: 'relative'}}>
													<select style={{width: '100%'}} className={"reasonCategory " + item.reasonCategoryError} value={item.reasonCategoryValue || ''} onChange={this.onChangeUpdateItems.bind(this, index)} name="reasonCategory">
														<option value="">Select</option>
														{dropdownOptions && dropdownOptions.map((it, ind) => {
															return <option key={ind} value={JSON.stringify(it)}>{it.label}</option>
														})}
													</select>
													{(item.reasonCategoryLabel === 'Credit Pricing Contract Substitution' || item.reasonCategoryLabel === 'Credit Pricing Retail ABD Substitution') && <div className="subbedModelBox">
														<div className={item.subbedModelError + ' auto-width-input'}>
															<div className="label">Subbed for model</div>
															<div className="textfield">
																<AccountNumberAutoSuggests
																	onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)}
																	itemIndex={index}
																	updateQuickOrderState={this.handleProductNumberChange.bind(this)}
																	size={8}
																	suggestionClass="width100per"
																	placeHolder="Model #"
																	value={item.subbedModel || ''}
																/>
															</div>
															{item.inValid
																?<span className="red">Invalid product Number.</span>
																:null
															}
														</div>
													</div>}
												</td>
											</tr>,
											self.state.creditType !== 'Delivery/Services/Fees' && (item.originalSerialNumbers || item.userItemDescription) && <tr key={200 + index}>
												{/* Dont show this section for delivery/services/fees section */}
												<td colSpan={ 6 } style={{paddingTop: 0}}>
													<div style={{marginTop: '.5rem'}}>
														<a
															href=""
															onClick={this.handleShowModalAddSerialNumber.bind(this, index, item)}
															className="bold js--add-serial"
															style={{float: 'left'}}
														>+ Add Serial Number(s)</a>
														<span style={{marginLeft: '1rem', color: 808080, float: 'left'}}>
															{item.serialNumber && item.serialNumber.split(" ").join(", ")}
															{item.serialNumberError && !item.serialNumber && <span className="red bold">Please select Serial Numbers.</span>}
															{item.serialNumberError && item.serialNumber && (item.serialNumber.split(" ").length !== parseInt(item.returnQuantity, 10)) && <span className="red bold"><br /><br />Please select the correct number of serials for the quantity being returned.</span>}
														</span>
													</div>
												</td>
											</tr>,
												self.state.creditType !== 'Delivery/Services/Fees' && (item.originalSerialNumbers == "" && item.userItemDescription == "" && item.itemType!="A") ? <tr key={300 + index}>
												<td className="text-right">
													Enter Serial # (s)
												</td>
												<td colSpan={ 5 }>
													<input type="text" className={"notesAboutReturn " + item.serialNumberError} onChange={this.onChangeUpdateItems.bind(this, index)} name="serialNumber" defaultValue={item.serialNumber} placeholder="Ex. AA123456, AA101234" style={{width: '95%'}} />
													{item.serialNumberError && item.serialNumber &&
														<span className="red bold"><br /><br />Please enter the correct number of serials, separate by commas, for the quantity being returned.</span>
													}
												</td>
											</tr>:<tr style={{borderBottom: '0 none'}}></tr>
										]
									})}
								</tbody>
							</table>
						</div>
						<div className="columns">
							<div className="column">
								<input onClick={(e) => this.handleGoToStep('/requestcredit', e)} type="button" defaultValue="Cancel" className="blueButton" />
							</div>
							<div className="column textRight">
								<input type="submit" onClick={this.handleSubmitStep2.bind(this)} value="Continue" />
							</div>
						</div>
						<p>
							<a href="" onClick={(e) => this.handleGoToStep('/requestcreditstep1', e)} className="bold">Return to previous screen</a>
						</p>

					</form>	{/* / .returnProductsForm#returnProductsForm */}
					{this.state.showModalAddSerialNumberOverlayDialog
						?
						<ModalAddSerialNumberOverlayDialog
							serialNumber={self.state.selectedSerialNumber}
							originalSerialNumbers={self.state.originalSerialNumbers}
							handleCallbackAfterSelect={this.handleCallbackAfterSelect.bind(this)}
							handleDialog={this.handleDialog}
							showDialog={true}
						/>
						:null
					}
				</div>

			{/*Mobile view*/}
				<div className="d-block d-sm-none container">
					<div className="push">
						<h1 className="pageTitle">Request Credit</h1>
					</div>

					<div className=''>
						<div className=''>
							<div className='col-12 fw-bold'>
								Return Date
							</div>
							<div className='col-12 fw-bold'>
								{this.state.requestCreditStep2Form.params.orderDate}
							</div>
						</div>
						<div className='mt-3'>
							<div className='col-12 fw-bold'>
								Order Type
							</div>
							<div className='col-12'>
							{this.state.requestCreditStep2Form.params.orderType}
							</div>
						</div>
						<div className='mt-3'>
							<div className='col-12 fw-bold'>
								P.O.<br />
										<i className="unbold">(for your reference)</i>
							</div>
							<div className='col-12'>
								<input onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.onChangeUpdateParam, undefined, undefined)} className={'txt-uppercase fullWidth form-control inputHeight ' + this.state.requestCreditStep2Form.errors.poNumberError} type="text" name="poNumber" onChange={this.onChangeUpdateParam.bind(this)} defaultValue={this.state.requestCreditStep2Form.params.poNumber} maxLength={50} />
							</div>
						</div>
						<div className='mt-3'>
							<div className='col-12 fw-bold'>
								Billing Address
							</div>
							{billingAddress && 
								<div className='col-12'>
							<p className="billingAddress">
											{billingAddress.addressName && billingAddress.addressName.trim()}
											{billingAddress.addressName && billingAddress.addressName.trim() !== ""?<br/>:null}
											{billingAddress.address1 && billingAddress.address1.trim()}
											{billingAddress.address1 && billingAddress.address1.trim() !== ""?<br/>:null}
											{billingAddress.city && billingAddress.city.trim()}, {billingAddress.state && billingAddress.state.trim()} {billingAddress.zip && billingAddress.zip.trim()}<br />
											{billingAddress.phone}
										</p>

							</div>}
						</div>
						<div className='mt-3'>
							<div className='col-12 fw-bold'>
								Contact Phone
							</div>
							<div className='col-12'>
								<input onKeyPress={this.props.acceptNumbersOnly} onBlur={this.onBlurValidatePhoneNumber.bind(this)} className={"phoneNumberField fullWidth form-control inputHeight "+this.state.requestCreditStep2Form.errors.deliveryPhoneError} type="text" onChange={this.onChangeUpdateParam.bind(this)} defaultValue={this.state.requestCreditStep2Form.params.deliveryPhone} name="deliveryPhone" size={17} maxLength={17} />
							</div>
						</div>
						<div className='mt-3'>
							<div className='col-12 fw-bold'>
								Credit Invoice Notes
							</div>
							<div className='col-12'>
								<textarea rows={6} cols={40} defaultValue={this.state.requestCreditStep2Form.params.creditInvoiceNotes} onChange={this.onChangeUpdateParam.bind(this)} name="creditInvoiceNotes" />
							</div>
						</div>
					</div>

					{orderDetails && orderDetails.items.map((item, index) => {
									let accessoryListflag =false;
									if(item.item == accessoryList && accessoryList.product_attr_val_disp){
										accessoryListflag =true;
									}
									if (!item.selected) return null;
									let dropdownOptions = JSON.parse(JSON.stringify(creditTypeDropdownOptions));
									if (self.state.creditType === 'Delivery/Services/Fees') {
										dropdownOptions = JSON.parse(JSON.stringify(self.fetchProperCreditReasonByItem(item.item)));
									}
									// Substitution reason codes (“Credit Pricing Contract Substitution” or “Credit Pricing Retail ABD Substitution”)
									// should not be offered if original account is Retail and the SA is Quote Type N.
									if(self.state.creditType === 'Price Adjustment - Credit/Rebill' && self.state.customerClassCode !== "single family"){
										dropdownOptions = dropdownOptions.filter(itm => itm.label !== "Credit Display Model Home Allow Direct Contract Only")
									}
									if (self.state.creditType === 'Price Adjustment - Credit/Rebill' &&self.props.getAttributeBySalesAgreement(item.agreementNumber, 'Quote Type') === 'N' && self.props.getSelectedAccountType() === 'RETAIL' )
									 {
										dropdownOptions = dropdownOptions.filter(itm => itm.label !== 'Credit Pricing Contract Substitution' && itm.label !== 'Credit Pricing Retail ABD Substitution');
									}
									if(self.state.creditType === 'Price Adjustment - Credit/Rebill' && (self.props.getSelectedAccountType() === 'RETAIL' || classCode.includes(self.state.customerClassCode))){
										dropdownOptions = dropdownOptions.filter(itm => 
											itm.label !== 'Credit Pricing Contract Exception Model Not On Quote'&&
											itm.label !== 'Credit Pricing Contract Late Addition Of Model To Quote'&&
											itm.label !== 'Credit Pricing Contract Price Change On Quote');
									}
					return <div className="accordion removeAccBorder accordion-borderless" id={`accordionRequestReturnCreditStep2${index}`}  key={index}>
									<div className="accordion-item">

										<h2 className="accordion-header" id={`headingReturnStep2${index}`}>
											<button className="accBtn accordion-button font-size-14 collapsed " type="button" data-bs-toggle="collapse" data-bs-target={`#collapseReturnStep2${index}`} aria-expanded="true" aria-controls={`collapseReturnStep2${index}`}>
											<span className='spaceBetweenText'>Product</span>  {item.item}
											</button>
										</h2>	

										<div id={`collapseReturnStep2${index}`}
															className="accordion-collapse collapse accBody show" 
															aria-labelledby={`headingReturnStep2${index}`}
															show>

											<div className="">
												{
													self.state.creditType !== 'Delivery/Services/Fees' && (item.originalSerialNumbers || item.userItemDescription) && 
														<div className="row pt-3" key={200 + index}>
															<div className="col-12">
																<a
																	href=""
																	onClick={this.handleShowModalAddSerialNumber.bind(this, index, item)}
																	className="bold js--add-serial"
																	style={{float: 'left'}}
																>+ Add Serial Number(s)</a>
																<span style={{marginLeft: '1rem', color: 808080, float: 'left'}}>
																	{item.serialNumber && item.serialNumber.split(" ").join(", ")}
																	{item.serialNumberError && !item.serialNumber && <span className="red bold">Please select Serial Numbers.</span>}
																	{item.serialNumberError && item.serialNumber && (item.serialNumber.split(" ").length !== parseInt(item.returnQuantity, 10)) && <span className="red bold"><br /><br />Please select the correct number of serials for the quantity being returned.</span>}
																</span>
															</div>
															<hr className="hr hrSpec" />
														</div>
												}

											
												<div className="row pt-3">
													<div className="col-8 fw-bold text-uppercase font-size-12">Quantity To Credit</div>
													<div className="col-4 text-end">{item.returnQuantity}</div>
													<hr className="hr hrSpec" />
												</div>

												<div className="row ">
													<div className="col-8 fw-bold text-uppercase font-size-12">Invoice #</div>
													<div className="col-4 text-end">{item.invoiceNumber}</div>
													<hr className="hr hrSpec" />
												</div>

												<div className="row ">
													<div className="col-4 fw-bold text-uppercase font-size-12 pt-2">Credit Type</div>
													<div className="col-8 text-end ">
														{this.state.creditType}
													</div>
													<hr className="hr hrSpec" />
												</div>

												<div className="row ">
													<div className="col-6 fw-bold text-uppercase font-size-12">Reason For Credit Request</div>
													<div className="col-6 text-end ">
														<select className={`form-select float-end w-100 ${item.reasonCategoryError}`} value={item.reasonCategoryValue || ''} onChange={this.onChangeUpdateItems.bind(this, index)} name="reasonCategory">
															<option value="">Select</option>
															{dropdownOptions && dropdownOptions.map((it, ind) => {
																return <option key={ind} value={JSON.stringify(it)}>{it.label}</option>
															})}
														</select>
													</div>
													<hr className="hr hrSpec" />
												</div>

												{(item.reasonCategoryLabel === 'Credit Pricing Contract Substitution' || item.reasonCategoryLabel === 'Credit Pricing Retail ABD Substitution') &&
													<div className="row ">
														<div className="col-6 fw-bold text-uppercase font-size-12 mt-2">SUBBED FOR MODEL</div>
														<div className={item.subbedModelError + " col-6"}>
															<AccountNumberAutoSuggests
																	onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)}
																	itemIndex={index}
																	updateQuickOrderState={this.handleProductNumberChange.bind(this)}
																	size={8}
																	suggestionClass="width100per"
																	placeHolder="Model #"
																	value={item.subbedModel || ''}
																/>
														</div>
														{item.inValid
																?<span className="red">Invalid product Number.</span>
																:null
															}
														<hr className="hr hrSpec" />
													</div>
												}

												<div className="row pb-3">
													<div className="col-8 fw-bold text-uppercase font-size-12 pt-2">Remove</div>
													<div className="col-4 text-end pt-2">
														<a className="deleteLink" href="" onClick={this.onDeleteItem.bind(this, index)} >✗</a>
													</div>
													
												</div>
											</div>
										</div>
									</div>
								</div>
							})}
					
						<div className="d-flex justify-content-between mt-3 ps-1 pe-1">
							<span>
								<button id="cancelButton" className='btnSize cancelButtonSpec' onClick={(e) => this.handleGoToStep('/requestcredit', e)}>Cancel</button>
							</span>
							
							<span>
								<button id="continueButton" className='btnSize' onClick={this.handleSubmitStep2.bind(this)}>Continue</button>
							</span>
						</div>
					

					<div className="container mt-4 backLink">
						<a href="" onClick={(e) => this.handleGoToStep('/requestcreditstep1', e)} className="bold">Return to previous screen</a>
						</div>

						{this.state.showModalAddSerialNumberOverlayDialog
						?
						<ModalAddSerialNumberOverlayDialog
							serialNumber={self.state.selectedSerialNumber}
							originalSerialNumbers={self.state.originalSerialNumbers}
							handleCallbackAfterSelect={this.handleCallbackAfterSelect.bind(this)}
							handleDialog={this.handleDialog}
							showDialog={true}
						/>
						:null
					}
					
					<div style={{height:"200px"}}></div>
					

				</div>

			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		order: state.order,
		user: state.user
	};
};

const mapDispatchToProps = (dispatch) => ({
	setRequestCreditDetails: (data) => dispatch(setRequestCreditDetails(data)),
	getAccountList: (queryStringParams, callback) => dispatch(getAccountList(queryStringParams, callback)),
});

RequestCreditStep2 = connect(mapStateToProps, mapDispatchToProps)(RequestCreditStep2);
export default RequestCreditStep2;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/RequestCredit/requestCreditStep2.js